var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3E6DC1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6650_61053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2101 21.2857V26.958H23.8908V21.6639C23.8908 20.3193 23.4286 19.437 22.2101 19.437C21.2857 19.437 20.7395 20.0672 20.5294 20.6555C20.4454 20.8655 20.4034 21.1597 20.4034 21.4538V27H17.084C17.084 27 17.1261 18.0084 17.084 17.084H20.4034V18.4706C20.4034 18.4706 20.4034 18.5126 20.3613 18.5126H20.4034V18.4706C20.8235 17.7983 21.6218 16.8319 23.3866 16.8319C25.5714 16.8319 27.2101 18.2605 27.2101 21.2857ZM12 27H15.2773V17.084H12V27ZM15.4034 13.6807C15.4034 14.605 14.6471 15.3613 13.7227 15.3613C12.7983 15.3613 12.042 14.605 12.042 13.6807C12.042 12.7563 12.7983 12 13.7227 12C14.6471 12 15.4034 12.7563 15.4034 13.6807Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6650_61053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2101,
    height: 15,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.bf6fdb98bbac31df3095a271ca2e0710.svg";
export { ForwardRef as ReactComponent };